import $ from "jquery";
import _ from "underscore";
import AmCharts from "../alias/amcharts";

export default class ChartGenerator {
    constructor() {}
}

ChartGenerator.prototype = {

    init: function(defaultChartSize)
    {
        this.defaultChartSize = defaultChartSize;
        return this;
    },

    /**
     * Render chart in given container
     * @param container container id for render chart
     * @param chartData data for render chart
     * @param config additional parameters/settings/callbacks
     */
    renderChart: function(container, chartData, config)
    {
        var settings = this._prepareChartSettings(chartData, config);
        settings = $.extend(true, settings, {
            "listeners": this._getEventListeners(config),
            "export": {
                "enabled": false,
                "menu": [],
                "libs": {
                    "autoLoad": false
                }
            }
        });

        return this._makeChart(container, settings);
    },

    /**
     * Render chart in given container and export to JPG
     * @param container container id for render chart
     * @param chartData data for render chart
     * @param config additional parameters/settings/callbacks
     */
    exportChartToJPG: function(container, chartData, config)
    {
        config["onRendered"] = function(e)
        {
            e["chart"]['export'].capture({}, function()
            {
                // SAVE TO JPG
                this.toJPG({}, function(base64)
                {
                    config["onExported"](base64);
                });
            })
        };

        var slicedChartData = chartData;
        if (!_.isUndefined(config["startIndex"]) && !_.isUndefined(config["endIndex"]))
        {
            slicedChartData = this._sliceChartData(chartData, config["startIndex"], config["endIndex"]);
        }

        var settings = this._prepareChartSettings(slicedChartData, config);
        settings = $.extend(true, settings, {
            "listeners": this._getEventListeners(config),
            "export": {
                "enabled": true,
                "menu": [],
                "libs": {
                    "autoLoad": false
                }
            }
        });
        this._updateSettingsForExport(settings, slicedChartData, config);
        
        return this._makeChart(container, settings)
    },

    /**
     *  Slices chart data
     */
    _sliceChartData: function(chartData, startIndex, endIndex)
    {
        if (startIndex == 0 && endIndex == chartData.length -1)
        {
            return chartData;
        }
        var slicedChartData = [];
        for (var i = startIndex; i <= endIndex; i++)
        {
            slicedChartData.push(chartData[i]);
        }
        return slicedChartData;
    },

    _makeChart: function(container, settings)
    {
        return AmCharts.makeChart(container, settings, 10);
    },

    /*
        Create event listeners for bind with chart
     */
    _getEventListeners: function(config)
    {
        var eventListeners = [{
            "event": "rendered",
            "method": function(e)
            {
                config["onRendered"](e);
            }
        }];
        eventListeners = eventListeners.concat(this._getAdditionalEventListeners(config));
        return eventListeners;
    },

    /*
        Get scale between default chart size and given chart size (it need for adjust fonts/weight/margins of chart elements)
     */
    _getChartScales: function(config)
    {
        var horizontal = 1;
        var vertical = 1;
        var chartSize = config["chartSize"];
        if (!_.isUndefined(chartSize))
        {
            horizontal = chartSize["width"] / this.defaultChartSize["width"];
            vertical = chartSize["height"] / this.defaultChartSize["height"];
        }
        return {
            "horizontal": horizontal,
            "vertical": vertical,
            "common": vertical
        }
    },

    /*
        Get additional event that will be bind with chart
     */
    _getAdditionalEventListeners: function(config)
    {
        return [];
    },

    /*
        Get main chart settings (see AmCharts docs)
     */
    _prepareChartSettings: function(chartData, config)
    {
        // abstract
    },

    /*
      Update settings for export
     */
    _updateSettingsForExport: function(settings, chartData, config)
    {
    }
};



// WEBPACK FOOTER //
// ./web/js/chart/ChartGenerator.js